<template>
  <div class="user-limit" :class="userLimitClasses">
    <img
      src="@/assets/svg/arrow-up.svg"
      :style="{
        opacity: scrollAfterSelection ? 0 : 1,
        transition: 'opacity 0.3s'
      }"
    />

    <transition name="fade" mode="out-in">
      <div v-if="!temporaryUserLimitSet" :key="0" class="wrapper">
        <transition-group name="fade" mode="out-in">
          <div key="1" class="call-to-scroll">
            {{ callToScrollText }}
          </div>
          <!--  <g-button
            v-if="!callToScroll"
            :key="2"
            narrow
            size="small"
            color="green"
            @click="setTemporaryUserLimit"
          >
            GÅ VIDARE
          </g-button> -->
        </transition-group>
      </div>

      <!-- div v-if="!callToScroll && !temporaryUserLimitSet" key="1">
        <g-button size="small" type="solid" @click="setTemporaryUserLimit">
          Sätt din gräns
        </g-button>
      </div -->
      <div
        v-if="!callToScroll && temporaryUserLimitSet"
        key="2"
        class="wrapper"
      >
        <div class="call-to-scroll">
          {{ limitSetFeedbackText }}
        </div>
        <g-button size="small" color="green" narrow @click="setUserLimit">
          GÅ VIDARE
        </g-button>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    temporaryUserLimitSet: {
      type: Boolean,
      default: false
    },
    callToScrollText: {
      type: String,
      default: ''
    },
    limitSetFeedbackText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      callToScroll: false,
      callToScrollSavedY: -1,
      scrollAfterSelection: false
    };
  },
  computed: {
    userLimitClasses() {
      return {
        show: this.visible,
        'top-border': !this.temporaryUserLimitSet
      };
    }
  },
  watch: {},
  methods: {
    setTemporaryUserLimit(e) {
      this.$emit('set-temporary-user-limit', e);
    },
    setUserLimit(e) {
      this.$emit('set-user-limit', e);
    },
    onScroll(e) {
      this.scrollAfterSelection = true;
      window.removeEventListener('scroll', this.onScroll);
    },
    tempLimitChanged() {
      setTimeout(() => {
        this.scrollAfterSelection = false;
        window.addEventListener('scroll', this.onScroll);
      }, 50);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-limit {
  align-items: center;
  backdrop-filter: blur(4px);
  background: rgba(254, 231, 217, 0.4);

  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 250px;
  justify-content: flex-start;
  left: 0;
  padding-top: 20px;
  position: fixed;
  transform: translateY(100%);
  transition: transform 0.9s ease-out;
  width: 100%;
  z-index: 3;

  &.show {
    transform: translateY(0);
  }

  &.top-border {
    border-top: 6px dotted $green;
  }

  img {
    margin-bottom: 10px;
  }

  .wrapper {
    max-width: $content-max-width;
    padding: 0 20px;
    width: 100%;
  }

  .call-to-ecpat,
  .call-to-scroll {
    border-radius: 20px;
    color: $white;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 10px;
    margin-top: 10px;
    padding: 25px;
  }

  .call-to-scroll {
    background-color: $green;
  }

  .call-to-ecpat {
    background-color: $brown;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
